import { render, staticRenderFns } from "./ScreenSpec.vue?vue&type=template&id=2edfb4f7&scoped=true&"
import script from "./ScreenSpec.vue?vue&type=script&lang=js&"
export * from "./ScreenSpec.vue?vue&type=script&lang=js&"
import style0 from "./ScreenSpec.vue?vue&type=style&index=0&id=2edfb4f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edfb4f7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/ui-spec-md/ui-spec-md/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('2edfb4f7', component.options)
    } else {
      api.reload('2edfb4f7', component.options)
    }
    module.hot.accept("./ScreenSpec.vue?vue&type=template&id=2edfb4f7&scoped=true&", function () {
      api.rerender('2edfb4f7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ScreenSpec.vue"
export default component.exports